import { render, staticRenderFns } from "./reval.vue?vue&type=template&id=a8ce0338&"
import script from "./reval.vue?vue&type=script&lang=ts&"
export * from "./reval.vue?vue&type=script&lang=ts&"
import style0 from "./reval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports